module.exports = __webpack_public_path__ + "img/header-diamondJewelrySignature@2x.ac9c51f.webp";